<template>
<div class="chapter">
<div class="inner_page">
<p class="h1" id="pro"><span class="epub-b">Personal Chronicle: Looking Back to 2014 …</span></p>
<p class="in"><span class="epub-i">Markus:</span></p>
<p class="ini"><span class="epub-i">In the late winter of 2014, your uncle Josh had stunned the world by appearing at the United Nations in New York City, telling the world how he had seen Chinese soldiers slaughter his scientific team and dozens of Vietnamese peasants. He brought back video and pictures. They were horrible images—little children dead, a nursing mother … I feel sick when I think of them. The images are burned into my brain.</span></p>
<p class="ini"><span class="epub-i">But even with this evidence, the people of the world were not convinced that the Chinese were a great threat that had to be stopped. Their leader, Premier Cho Lai, was an evil man, but he was very clever. He plotted to undermine the evidence that your uncle had brought back. And to kill him and the people who helped him escape.</span></p>
<p class="ini"><span class="epub-i">But that was just our own personal tragedy.</span></p>
<p class="ini"><span class="epub-i">The whole world teetered on the brink of war. Far away in Southeast Asia, Vietnam was about to be overrun. A few ships from the American Navy, and a handful of advisers from the Army, were all that stood in the way.…</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// prologue.vue?0aa3534b